<script setup lang="ts">
import { computed, ref } from 'vue'
import { Timesheets } from '../../types/timers'
import TimelineScorecard from '../TimelineScorecard.vue'
import { formatTimesheetsForTable } from '../../store/timesheets'
import { useFormatTime } from '../../composables/formatTime'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { Table } from '../../types/components/data-rendering'
import BaseModal from '../wrappers/BaseModal.vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  timesheets: Timesheets
}>()

//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`payPeriod.${key}`)
const form = (key: string) => t(`form.${key}`)

const totalTime = computed(() => {
  const data = props.timesheets.reduce((acc, timesheet) => {
    return acc + timesheet.toBePaidHours
  }, 0)

  return useFormatTime(data, { format: 'h:mm', initTime: 'minutes' })
})

const activities = computed((): Table => {
  return formatTimesheetsForTable(props.timesheets)
})
const value = ref(false)
</script>

<template>
  <TimelineScorecard
    @click="value = true"
    :header="label('toBePaidHours')"
    :subheader="totalTime"
  />
  <BaseModal v-if="activities" v-model="value">
    <template #title>{{ `${form('total')}: ${totalTime}` }}</template>
    <template #content>
      <FilteringDataDisplay :table-data="activities" :enable-filters="false" />
    </template>
    <template #actions>
      <q-btn rounded flat :label="form('close')" v-close-popup />
    </template>
  </BaseModal>
</template>
